import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-toast',
  templateUrl: './toast.component.html',
  standalone: false,
})
export class ToastComponent {
  @Input()
  message?: string;

  @Input()
  type?: string;
}
